import gsap from 'gsap';

const animateIn = ({ wrapperRef, animatedIn, animatedOut }) => {
  const delay = 0.02;
  gsap.killTweensOf(wrapperRef.current);
  animatedIn.current = true;
  animatedOut.current = false;
  gsap.to(wrapperRef.current, {
    y: 0,
    opacity: 1,
    duration: 0.25,
    delay,
    ease: 'cubic-bezier(0,0,0,0)',
  });
};

const animateOut = ({ wrapperRef, animatedOut, animatedIn }) => {
  const delay = 0.02;
  animatedOut.current = true;
  if (!animatedIn.current) {
    gsap.to(wrapperRef.current, {
      y: 15,
      opacity: 0,
      duration: 0.35,
      delay,
      ease: 'cubic-bezier(0,0,0,0)',
    });
  }
};

export function animateUpdate({ progress, refs }) {
  const { wrapperRef, animatedIn, animatedOut } = refs?.current || {};

  const doIn = !animatedIn.current && progress > 0.03 && progress < 0.9;
  const doOut = !animatedOut.current && progress <= 0.03;

  if (doIn) {
    animateIn({ wrapperRef, animatedIn, animatedOut });
  }

  if (doOut) {
    animateOut({ wrapperRef, animatedOut, animatedIn });
  }
}
